import { gql } from "@grandvisionhq/graphql";
const listStoreGroups = gql`
  fragment ListStoreGroups on StoreGroups {
    singleStoreGroups {
      name
      store {
        slug
        town
      }
    }
    multiStoreGroups {
      name
      slug
    }
  }
`;
const GET_LIST_STORE_GROUPS = gql`
  query GetListStoreGroupsForOverview {
    listStoreGroups {
      ...ListStoreGroups
    }
  }
  ${listStoreGroups}
`;
export {
  GET_LIST_STORE_GROUPS
};
//# sourceMappingURL=queries.js.map
